import React from "react";
import { trustBadges, WHATSAPP_URL } from "../data/content";
import "./Hero.css";

export default function Hero() {
  return (
    <section className="hero">
      {/* Left: Content */}
      <div className="hero-content">
        <div className="hero-eyebrow">Ayurvedic Wellness · Made in India</div>

        <h1 className="hero-title">
          Nature's Answer
          <br />
          to <em>Healthy Blood</em>
          <br />
          Sugar Levels
        </h1>

        <p className="hero-subtitle">
          Diabetic Wellness Powder — 4 Sacred Herbs, One Formula
        </p>

        <p className="hero-desc">
          Crafted with centuries-old traditional herbs — Karela, Neem, Methi
          &amp; Amla — our Diabetic Wellness Powder works holistically to
          support healthy glucose metabolism, boost energy, and nourish your
          body from within.
        </p>

        <div className="hero-actions">
          <a href="#order" className="btn-primary">
            Order Now →
          </a>
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-primary btn-whatsapp"
          >
            💬 WhatsApp Us
          </a>
        </div>

        <div className="hero-trust">
          {trustBadges.map((badge) => {
            const Icon = badge.icon;
            return (
              <div className="trust-badge" key={badge.label}>
                <span>
                  {typeof Icon === "string" ? Icon : <Icon size={16} />}
                </span>
                {badge.label}
              </div>
            );
          })}
        </div>
      </div>

      {/* Right: Visual */}
      <div className="hero-visual">
        <div className="hero-circle">
          <div className="product-bowl">🥣</div>
          <div className="orbit-pill orbit-1">🌿 Karela</div>
          <div className="orbit-pill orbit-2">🍃 Neem</div>
          <div className="orbit-pill orbit-3">🌾 Methi</div>
          <div className="orbit-pill orbit-4">🫐 Amla</div>
        </div>
      </div>
    </section>
  );
}
